export default "__VITE_ASSET__BxyKcLEk__"